import type { ComponentPropsWithoutRef } from "react";

export const PersonIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M12.7207 13C15.4821 13 17.7207 10.7614 17.7207 8C17.7207 5.23858 15.4821 3 12.7207 3C9.95928 3 7.7207 5.23858 7.7207 8C7.7207 10.7614 9.95928 13 12.7207 13ZM12.7207 13C14.8424 13 16.8773 13.8429 18.3776 15.3431C19.8778 16.8434 20.7207 18.8783 20.7207 21M12.7207 13C10.599 13 8.56414 13.8429 7.06385 15.3431C5.56356 16.8434 4.7207 18.8783 4.7207 21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
